import { EstatePlanPartyType } from '@/modules/estate/enums/EstatePlanPartyType';
import { PartnershipInvitationType } from '@/modules/partnershipinvitation/constants/PartnershipInvitationType';

export const LightDiagnosticMixin = {
  emits: ['on-goals-input', 'on-situations-input', 'custom-flow-change', 'on-early-exit-clicked'],
  props: {
    showBillingPlan: {
      type: Boolean,
      default: true
    },
    jurisdictionId: {
      type: Number,
      required: false
    },
    showCoupleToggle: {
      type: Boolean
    },
    hideBackButton: {
      type: Boolean,
      default: true
    },
    hasEarlyExit: {
      type: Boolean,
      default: false
    },
    hasTitlePrimary: {
      type: Boolean,
      default: true
    },
    hasCallToAction: {
      type: Boolean,
      default: false
    },
    estatePlanPartyType: {
      // type: Object as PropType<EstatePlanPartyType>
      type: Object
    },
    isExternal: {
      type: Boolean,
      default: false
    },
    partnershipInvitationType: {
      // type: Object as PropType<PartnershipInvitationType>
      type: Object,
      default() {
        return PartnershipInvitationType.CLIENT;
      }
    }
  },
  computed: {
    computedClass() {
      return this.hasTitlePrimary ? 'has-text-primary' : '';
    }
  },
  methods: {
    onEarlyExitClicked() {
      this.$emit('on-goals-input', []);
      this.$emit('on-situations-input', []);
      this.$emit('custom-flow-change');
      this.$emit('on-early-exit-clicked');
    }
  }
};
